import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { PaginatedRequestResponse, RequestResponse, Store } from '@/types';
import type { DomainAvailability } from './response';

export const fetchStores = async () => {
  const response = await axiosInstance<PaginatedRequestResponse<Store[]>>(
    endpoints.stores
  );
  return response.data.data.data;
};

export const fetchStore = async (id: string) => {
  const response = await axiosInstance<RequestResponse<Store>>(
    `${endpoints.stores}/${id}`
  );
  return response.data.data;
};

export const checkDomainAvailability = async (domain: string) => {
  const response = await axiosInstance.get<RequestResponse<DomainAvailability>>(
    endpoints.checkDomain,
    {
      params: { domain },
    }
  );
  return response.data.data;
};
